/** Default size for PAL IFP payment popup (px). */
export const IFP_PAL_PAYMENT_POPUP_WIDTH = 1200;
export const IFP_PAL_PAYMENT_POPUP_HEIGHT = 800;

/** Single window.name for loading + iframe popups (reuse / debug). */
export const IFP_PAL_PAYMENT_POPUP_WINDOW_NAME = 'IFPPalPayment';

/**
 * Window.open feature string: size + position centered on the opener window,
 * clamped to the available screen so the popup stays on-screen.
 */
export function buildIfpPalPaymentPopupFeatures() {
  const width = IFP_PAL_PAYMENT_POPUP_WIDTH;
  const height = IFP_PAL_PAYMENT_POPUP_HEIGHT;
  const margin = 16;

  const sx = window.screenX ?? window.screenLeft ?? 0;
  const sy = window.screenY ?? window.screenTop ?? 0;
  const ow = window.outerWidth;
  const oh = window.outerHeight;

  const availLeft = window.screen.availLeft ?? 0;
  const availTop = window.screen.availTop ?? 0;
  const rawAvailW = window.screen.availWidth ?? window.screen.width ?? 0;
  const rawAvailH = window.screen.availHeight ?? window.screen.height ?? 0;
  const availW = Math.max(rawAvailW, width + 2 * margin);
  const availH = Math.max(rawAvailH, height + 2 * margin);

  let left = Math.round(sx + (ow - width) / 2);
  let top = Math.round(sy + (oh - height) / 2);

  const minLeft = availLeft + margin;
  const maxLeft = availLeft + availW - width - margin;
  const minTop = availTop + margin;
  const maxTop = availTop + availH - height - margin;

  left = Math.min(Math.max(minLeft, left), Math.max(minLeft, maxLeft));
  top = Math.min(Math.max(minTop, top), Math.max(minTop, maxTop));

  if (!Number.isFinite(left)) left = minLeft;
  if (!Number.isFinite(top)) top = minTop;

  return `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes,toolbar=no,menubar=no,location=no`;
}
